import React from 'react';
import {View, ViewStyle} from 'react-native';

import {STAGGER, STEPPER_DIMENSIONS} from '../constants';

import {Bone} from './Bone';

type BoneStepperProps = {
  animationDelay?: number;
  style?: ViewStyle;
};

export const BoneStepper: React.FC<BoneStepperProps> = React.memo(({animationDelay = 0, style}) => {
  const s = STEPPER_DIMENSIONS;
  return (
    <View style={[{flexDirection: 'row', gap: s.gap}, style]}>
      <Bone
        width={s.buttonSize}
        height={s.buttonSize}
        borderRadius={s.borderRadius}
        animationDelay={animationDelay}
      />
      <Bone
        width={s.counterWidth}
        height={s.buttonSize}
        borderRadius={s.borderRadius}
        animationDelay={animationDelay + STAGGER.interval}
      />
      <Bone
        width={s.buttonSize}
        height={s.buttonSize}
        borderRadius={s.borderRadius}
        animationDelay={animationDelay + STAGGER.interval * 2}
      />
    </View>
  );
});

BoneStepper.displayName = 'BoneStepper';
